var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V59.6364H496V16Z",
    fill: "#E32D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 59.6367H16V103.273H496V59.6367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 103.272H16V146.909H496V103.272Z",
    fill: "#E32D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 146.909H16V190.546H496V146.909Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 190.546H16V234.182H496V190.546Z",
    fill: "#E32D3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M496 234.183H16V277.819H496V234.183Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496 277.818H16V321.455H496V277.818Z",
    fill: "#E32D3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M496 321.455H16V365.091H496V321.455Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M496 365.091H16V408.727H496V365.091Z",
    fill: "#E32D3C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M496 408.728H16V452.364H496V408.728Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M496 452.363H16V496H496V452.363Z",
    fill: "#E32D3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216 16H16V234.182H216V16Z",
    fill: "#356BA0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116 59.6367L132.381 109.665H185.431L142.45 140.517L158.881 190.546L116 159.644L73.0686 190.546L89.4998 140.517L46.5684 109.665H99.6189L116 59.6367",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/LR.a4e74c9eb98d5d66158bd46ca4cd3f2f.svg";
export { ForwardRef as ReactComponent };